import {
  fetchGetStationVehiclesFromCurrentSemanticMap,
  fetchGetMissionsInQueueFromCurrentSemanticMap,
  fetchGetStationVehiclesFromCurrentSemanticMapAndStationId,
  fetchPatchVehicleConfirmation,
  fetchReleaseMissionStop,
} from "./actions";
import {
  getStationVehicles,
  getIsStationEmpty,
  getIsStationVehiclesLoaded,
  getIsStationVehiclesLoadingError,
  getMissionsInQueue,
  getIsMissionsInQueueLoaded,
  getIsMissionsInQueueLoadingError,
  getIsMissionsInQueueEmpty,
} from "./selectors";
import StationConfirmationSlice from "./reducers";

// actions
export const {
  resetStations,
  updateStationConfirmation,
  setInitStationConfirmation,
} = StationConfirmationSlice.actions;

// async actions
export {
  fetchGetStationVehiclesFromCurrentSemanticMap,
  fetchGetMissionsInQueueFromCurrentSemanticMap,
  fetchGetStationVehiclesFromCurrentSemanticMapAndStationId,
  fetchPatchVehicleConfirmation,
  fetchReleaseMissionStop,
};

// selectors
export {
  getStationVehicles,
  getIsStationEmpty,
  getIsStationVehiclesLoaded,
  getIsStationVehiclesLoadingError,
  getMissionsInQueue,
  getIsMissionsInQueueLoaded,
  getIsMissionsInQueueLoadingError,
  getIsMissionsInQueueEmpty,
};

export default StationConfirmationSlice.reducer;
